import plur from "plur";
import { Text, Table, TableBody, TableCell, TableHeader, TableRow } from "@jsq/ds/core";
import Money, { MoneyType } from "~/components/Money";
import { SPACING } from "~/styles/variables";
import { FundAdminRequestedServiceObjects } from "../types";
import { hasObjectsWithAmounts } from "../utils";

interface Props {
  requestType: string;
  alsoHasEntityObjects: boolean;
  fundFamilyObjects: FundAdminRequestedServiceObjects;
}

const FundFamilyObjectsTable = ({
  requestType,
  alsoHasEntityObjects,
  fundFamilyObjects,
}: Props) => {
  const isEntitiesWithAmounts = hasObjectsWithAmounts(fundFamilyObjects);

  const getObjectDetailsAmount = (objectDetailsString: any): MoneyType => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-argument
    const objectDetails: MoneyType = JSON.parse(objectDetailsString ?? "");
    return objectDetails;
  };

  return (
    <div css={{ marginBottom: alsoHasEntityObjects ? SPACING.MEDIUM : "" }}>
      <Table condensed>
        <TableHeader>
          <TableRow>
            <TableCell>Fund family</TableCell>
            {isEntitiesWithAmounts && (
              <TableCell
                css={{
                  width: "150px",
                }}
                rightAligned
              >
                {requestType} amount
              </TableCell>
            )}
          </TableRow>
        </TableHeader>
        {/*eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-ignore */}
        <TableBody>
          {fundFamilyObjects.map((fundFamily) => {
            if (fundFamily.objectValue.__typename !== "EntityCollectionObjectType") {
              return null;
            }

            const entities =
              fundFamily.objectValue.entitiesFromCanopy?.edges?.map(({ node }) => node) ?? [];
            return (
              <TableRow alignment="top" key={fundFamily.objectValue.id}>
                <TableCell>
                  <Text>{fundFamily.objectValue.name}</Text>
                  <Text variant="secondary-sm" css={{ marginBottom: SPACING.SMALL }}>
                    Fund family with {entities.length} related {plur("entity", entities.length)}
                  </Text>
                  {entities.map((entity) => (
                    <Text
                      key={entity.id}
                      css={{ marginLeft: SPACING.MEDIUM, marginBottom: SPACING.SMALL }}
                    >
                      {entity.name}
                    </Text>
                  ))}
                </TableCell>
                {isEntitiesWithAmounts && (
                  <TableCell rightAligned>
                    <Money money={getObjectDetailsAmount(fundFamily.objectDetails)} />
                  </TableCell>
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default FundFamilyObjectsTable;
